import { useEffect, useState } from 'react';

/** Subscribe to a CSS media query and re-render on change. SSR-safe (defaults
 *  to false when window is unavailable). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

/** True on phone-width viewports (≤ 768px). */
export const useIsMobile = () => useMediaQuery('(max-width: 768px)');
/** True on narrow/tablet viewports (≤ 1024px). */
export const useIsNarrow = () => useMediaQuery('(max-width: 1024px)');
